import work1 from "./workout/work1.jpg"
import work2 from "./workout/work2.jpeg"
import work3 from "./workout/work3.jpeg"
import work4 from "./workout/work4.jpg"
import work5 from "./workout/work5.jpeg"
import work6 from "./workout/work6.jpg"
import work7 from "./workout/work7.jpeg"
import work8 from "./workout/work8.jpeg"
import work9 from "./workout/work9.jpeg"
import work10 from "./workout/work10.jpeg"
export const Progs = () => {
	return [
		{
			title: "Group",
			Img: work1,
			SecImg: work6,
			url: "/programs/work1",
			description:
				"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi, modi quia neque assumenda consequuntur officia temporibus. Dolores velit earum nemo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, debitis.Lorem ipsum dolor sit amet consectetur adipisicing elit. Non corrupti harum officiis eaque maiores dignissimos soluta voluptatem sed, quibusdam delectus.",
		},
		{
			title: "Freestyle",
			Img: work2,
			SecImg: work7,
			url: "/programs/work2",
			description:
				"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi, modi quia neque assumenda consequuntur officia temporibus. Dolores velit earum nemo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, debitis.Lorem ipsum dolor sit amet consectetur adipisicing elit. Non corrupti harum officiis eaque maiores dignissimos soluta voluptatem sed, quibusdam delectus.",
			
		},
		{
			title: "Cardio",
			Img: work3,
			SecImg: work8,
			url: "/programs/work3",
			description:
				"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi, modi quia neque assumenda consequuntur officia temporibus. Dolores velit earum nemo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, debitis.Lorem ipsum dolor sit amet consectetur adipisicing elit. Non corrupti harum officiis eaque maiores dignissimos soluta voluptatem sed, quibusdam delectus.",
		},
		{
			title: "Strength",
			Img: work4,
			SecImg: work9,
			url: "/programs/work4",
			description:
				"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi, modi quia neque assumenda consequuntur officia temporibus. Dolores velit earum nemo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, debitis.Lorem ipsum dolor sit amet consectetur adipisicing elit. Non corrupti harum officiis eaque maiores dignissimos soluta voluptatem sed, quibusdam delectus.",
		},
		{
			title: "Personal",
			Img: work5,
			SecImg:  work10,
			url: "/programs/work5",
			description:
				"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi, modi quia neque assumenda consequuntur officia temporibus. Dolores velit earum nemo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, debitis.Lorem ipsum dolor sit amet consectetur adipisicing elit. Non corrupti harum officiis eaque maiores dignissimos soluta voluptatem sed, quibusdam delectus.",
		},
	];
};
